import React, { forwardRef, memo } from 'react';

import * as Types from '@core/js/components/common/I18n/types';
import { useTranslations } from '@core/js/hooks/i18n';

import { useParseHtmlElements } from '@interlayer/js/custom/hooks/useParseHtmlElements';

const I18nBare = forwardRef<HTMLSpanElement, Types.II18nProps>(({
    className = '',
    defaultValue,
    replacers = [],
    t,
    tKey = ''
}, ref) => {
    const defaultTranslate = useTranslations();
    const translate = t || defaultTranslate;
    const tValue = translate(tKey, replacers, defaultValue);

    const parseHtmlElements = useParseHtmlElements();

    if (!tValue) {
        return null;
    }

    return <span ref={ref} className={className}>{parseHtmlElements(tValue)}</span>;
});

export const I18n = memo(I18nBare);
